module.exports = __webpack_public_path__ + "assets/images/tutorial7.c3c7331.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/tutorial/tutorial7.png
// module id = 458
// module chunks = 1